//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

/**
 * Compile-time exhaustiveness helper.  TypeScript narrows a discriminated
 * union to `never` at the default arm of a complete switch; adding a variant
 * without handling it fails the build at every call site.  At runtime it
 * throws — the branch should be unreachable, and if it ever fires the message
 * points at the contract bug.
 */
export const assertNever = (x: never): never => {
  throw new Error(
    `assertNever fired — unhandled discriminant: ${JSON.stringify(x)}`
  );
};
